import React from "react";
import Services from "../components/Services";
import WhatWeDo from "../components/WhatWeDo";
import DirectHireContractServices from "../components/DirectHireContractServices";
import WhyChooseClevanoo from "../components/WhyChooseClevanoo";

const ServicesPage = () => {
  return (
    <>
      <Services />
      <WhyChooseClevanoo />
      <WhatWeDo />
      <DirectHireContractServices />
    </>
  );
};

export default ServicesPage;
